export type ProjectScope = {
    discipline: string
    scope: string
    timeline: string
    team: string
}

export const scopeIntro = "Most projects bring two or three of our disciplines together in the same room. Here is roughly how each one runs on its own, so the first call can start from something concrete."

export const projectScopes: ProjectScope[] = [
    {
        discipline: "Direction",
        scope: "Positioning, art direction and campaign concepts",
        timeline: "3 to 5 weeks",
        team: "2 to 3 people"
    },
    {
        discipline: "Identity",
        scope: "Marks, type and colour systems, packaging, web",
        timeline: "8 to 12 weeks",
        team: "3 to 4 people"
    },
    {
        discipline: "Film",
        scope: "Brand films, campaign spots and documentaries",
        timeline: "6 to 14 weeks",
        team: "4 to 6 people"
    },
    {
        discipline: "Editorial",
        scope: "Books, magazines, photography and post",
        timeline: "4 to 10 weeks",
        team: "2 to 4 people"
    }
]
